import React from "react"
import ContentfulRichText from "../../utilities/contentful-rich-text"
import isTooDark from "../../utilities/is-too-dark"

const SimpleText = ({
  backgroundColor,
  text,
}: {
  backgroundColor: string
  text: { raw: string }
}) => {
  const textColor = isTooDark(backgroundColor) ? "#ffffff" : "#000000"
  return (
    <div
      className='text-center simple-text-section relative z-10'
      style={{ backgroundColor: backgroundColor, color: textColor }}
    >
      <div
        className={`inner-container simple-text-container${
          isTooDark(backgroundColor) ? " dark-bg" : ""
        }`}
      >
        <ContentfulRichText raw={text} className='text-[25px]' />
      </div>
    </div>
  )
}

export default SimpleText
